import { getAuthHeaders, tempMeeApi } from '~/services/api';
import type { IGetCandidateResumeApiResponse } from '../types/CandidateResume.api';
import type { IGetCandidateResumePayload } from '../types/CandidateResume.parameters';

export const getCandidateResume = async (
  payload: IGetCandidateResumePayload,
): Promise<IGetCandidateResumeApiResponse> => {
  const headers = await getAuthHeaders();

  const response = await tempMeeApi.get<IGetCandidateResumeApiResponse>(
    `/recruitment-service/candidates/professionals/${payload.professionalId}/resume`,
    {
      headers,
      params: payload.postingId ? { postingId: payload.postingId } : undefined,
    },
  );

  return response.data;
};
